import { Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DistributorService } from '../../../../services/distributor.service';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { StihlDistributorMaterialSendingDTO } from 'src/app/models/stihl-distributor-dto';
import { LanguageApp } from 'src/app/config/datatable-config';

@Component({
  selector: 'material-sending',
  templateUrl: './material-sending.component.html'
})

export class CommonMaterialSendingComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  dataform: FormGroup;
  modelData: StihlDistributorMaterialSendingDTO = new StihlDistributorMaterialSendingDTO();
  isEdit = false;
  showData = false;
  submitted = 0;
  textButton = "Nova morada de entrega";
  listenerFn: () => void;
  constructor(private distributorService: DistributorService, private toastr: ToastrService, private renderer: Renderer2) {
  }

  ngOnInit() {

    this.setDatatable();
    const numberRegex = /^\d+$/;
    this.dataform = new FormGroup({
      IdDistributorMaterialSending: new FormControl(null),
      IdDistributor: new FormControl(0),
      Addressee: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
      Contact: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
      AddressStreet: new FormControl(null, [Validators.required, Validators.maxLength(500)]),
      AddressNumber: new FormControl(null, [Validators.maxLength(50)]),
      AddressZip: new FormControl(null, [Validators.required, Validators.maxLength(50),Validators.pattern(numberRegex)]),
      AddressCity: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
      AddressRegion: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
      Phone: new FormControl(null, [Validators.required, Validators.maxLength(50),Validators.pattern(numberRegex)]),
      Mail: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
      Comments: new FormControl(null, [Validators.maxLength(500)])
    });

  }

  saveEvent() {

    this.submitted = 1;

    if (this.dataform.invalid) return;

    this.modelData = this.dataform.value;

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Aguarde por favor…'
    });
    Swal.showLoading();

    if (!this.isEdit)
      this.postData();
    else
      this.putData();

  }

  postData() {

    this.distributorService.postMaterialSending(this.modelData).subscribe(resp => {

      this.toastr.success("O registo foi criado com sucesso");
      this.dataform.reset();
      this.dataform.controls['IdDistributor'].setValue(0);
      this.rerender();
      this.showData = false;
      this.submitted = 0;
      this.textButton = "NOVOS DADOS DE ENVIO";
      Swal.close();

    }, (err) => {

      Swal.fire({
        icon: 'error',
        title: 'Erro ao criar',
        text: 'Ocorreu um erro'
      });
    });
  }

  putData() {

    this.distributorService.putDistributorMaterialSending(this.modelData.IdDistributorMaterialSending, this.modelData).subscribe(resp => {

      this.toastr.success("Os dados foram atualizados com sucesso");
      this.dataform.reset();
      this.dataform.controls['IdDistributor'].setValue(0);
      this.rerender();
      this.showData = false;
      this.submitted = 0;
      this.textButton = "NOVOS DADOS DE ENVIO";
      this.isEdit = false;

      Swal.close();
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao atualizar',
        text: 'Ocorreu um erro'
      });
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
    this.listenerFn = this.renderer.listen('document', 'click', (event) => {

      if (event.target.hasAttribute("material-edit-id")) {

        const id = event.target.getAttribute("material-edit-id");

        this.distributorService.getDistributorMaterialSending(id).subscribe(res => {

          this.modelData = res;
          this.isEdit = true;
          this.modelData = res;
          this.dataform.patchValue(this.modelData);
          this.showData = true;
          this.textButton = "CANCELAR";

        });

      }
      else if (event.target.hasAttribute("material-delete-id")) {

        const id = event.target.getAttribute("material-delete-id");

        this.delete(id);

      }

    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    if (this.listenerFn) {
      this.listenerFn();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }


  setDatatable() {
    const that = this;
    this.dtOptions = {
      ajax: (dataTablesParameters: any, callback) => {

        that.distributorService.getDistributoMaterialSendingDataTable(dataTablesParameters).subscribe(resp => {
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
        }, (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Erro ao recuperar os dados',
            text: 'Ocorreu um erro'
          });

        });
      },
      columns: [

        { data: "Destinatario", orderable: false },
        { data: "Contacto", orderable: false },
        { data: "Direccion", orderable: false },
        { data: "Telefono", orderable: false },
        { data: "Mail", orderable: false },
        { data: "Comentario", orderable: false },
        { data: "Id", orderable: false }

      ],
      columnDefs: [
        {
          targets: [0],
          data: "Destinatario",
          className: "text-left"
        },
        {
          targets: [1],
          data: "Contacto",
          className: "text-left"
        },
        {
          targets: [2],
          data: "Direccion",
          className: "text-left"
        },
        {
          targets: [5],
          data: "Comentario",
          className: "text-left"
        },
        {
          targets: [6],
          data: "Id",
          render: function (data, type, full) {
            var retorno = "";
            retorno += '<div class="cont__btn-option"><button material-edit-id="' + data + '" class="btn-option btn-option-edit" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Editar"></button>';
            retorno += '<button material-delete-id="' + data + '"class="btn-option btn-option-delete" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Eliminar"></button></button></div>';
            return retorno;
          }
        }
      ],
      responsive: false,
      paging: true,
      pageLength: 10,
      ordering: false,
      lengthChange: false,
      info: false,
      serverSide: true,
      language: LanguageApp.spanish_datatables,
      processing: true
    };
  }



  delete(id) {
    Swal.fire({
      title: 'Deseja remover este item?',
      text: "O item irá desaparecer ao administrador",
      icon: 'warning',
      showCancelButton: true,
      allowOutsideClick: false,
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn-orange-border mx-1',
        confirmButton: 'btn-orange mx-1'
      },
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        this.distributorService.deleteDistributorMaterialSending(id).subscribe(() => {
          this.toastr.success("O item foi removido com sucesso");
          this.dataform.reset();
          this.dataform.controls['IdDistributor'].setValue(0);
          this.rerender();
          this.showData = false;
          this.submitted = 0;
          this.textButton = "NOVOS DADOS DE ENVIO";
          this.isEdit = false;
        }, (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Erro ao eliminar o item',
            text: 'Ocorreu um erro'
          });
        });
      }
    })
  }

  showDataToggle() {

    this.showData = !this.showData;

    if (this.showData) {

      this.textButton = "CANCELAR";

    } else {

      this.textButton = "NOVOS DADOS DE ENVIO";
      this.dataform.reset();
      this.dataform.controls['IdDistributor'].setValue(0);
      this.submitted = 0;

    }
  }
}
